module.exports = __webpack_public_path__ + "static/media/16-above-scan-1.c389ea5e.png";